import React from 'react';
import { IQueryContext } from 'framework/context/IQueryContext';
import { IDocument, IDocumentsQueryParams, IQueryResult } from 'gen/ApiClient';

export const QueryContext = React.createContext<IQueryContext<IQueryResult<IDocument>, IDocumentsQueryParams>>(undefined as any);
